export const ROUTE_AUTH = 'ROUTE_AUTH'
export const ROUTE_AUTH_PASSWORD_DEFINE = 'ROUTE_AUTH_PASSWORD_DEFINE'

export const ROUTE_SETTINGS = 'ROUTE_SETTINGS'
export const ROUTE_CALENDAR = 'ROUTE_CALENDAR'

export const ROUTE_PROVISION = 'ROUTE_PROVISION'
export const ROUTE_ATTENDANCE_NEW = 'ROUTE_ATTENDANCE_NEW'
export const ROUTE_ATTENDANCE_ITEM = 'ROUTE_ATTENDANCE_ITEM'
export const ROUTE_ATTENDANCE_OFFER = 'ROUTE_ATTENDANCE_OFFER'

export const ROUTE_PREVIEW = 'ROUTE_PREVIEW'
export const ROUTE_PREVIEW_DETAILS = 'ROUTE_PREVIEW_DETAILS'
export const ROUTE_PREVIEW_CURRENT = 'ROUTE_PREVIEW_CURRENT'
